<template>
    <div class="bg"></div>
</template>

<script>
export default {};
</script>

<style scoped>
.bg {
    background: #f3f3f3;
    /* background: linear-gradient(210deg, white, var(--v-secondary-lighten5)); */
    min-height: 100vh;
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    /* opacity: .1; */
}
</style>